import { useEffect, useState } from 'react'
import { useActor, useMachine } from '@xstate/react'
import { Link } from 'react-router-dom'
import { myGiftsMachine } from '../../xstate/mygifts.machine'
import styles from './MyGifts.module.scss'
import { Banners } from '../Banners/Banners'
import { Icon } from '../SVGsprite/svgsprite'
import { Loader } from '../Loader/Loader'
import { Pagination } from '../Pagination/Pagination'
import { NoData } from '../NoData/NoData'
import { AuthState } from '../../xstate/auth.machine'
import { useCallback } from 'react'
import apiMethods from '../../api/apiMethods'

export function MyGifts() {
	const [stateAuth] = useActor(AuthState)
	const [stateGifts, sendGifts] = useMachine(myGiftsMachine)

	useEffect(() => {
		document.title = 'Мои подарки | Программа лояльности SK ZIC'
	}, [])

	return (
		<>
			<section className={styles.workarea}>
				<div className='titleBlock'>
					<h1>Мои подарки</h1>
					{!['owner', 'distributor'].includes(stateAuth.context.type) && (
						<Link to='/shop' className='btn btnPrimary btnIcon'>
							<Icon name='icon-add' sizeW='24' sizeH='24' />
							Заказать подарок
						</Link>
					)}
				</div>
				<div className='statContainer'>
					{stateGifts.matches('loading') ? (
						<Loader />
					) : (
						<>
							<GiftsTable
								data={stateGifts.context.list}
								sendGifts={sendGifts}
							/>
							{stateGifts.context.pages > 1 && (
								<Pagination
									pages={stateGifts.context.pages}
									current_page={stateGifts.context.current_page}
									send={sendGifts}
								/>
							)}
						</>
					)}
				</div>
			</section>
			<aside className={styles.sidebar}>
				{/* <Bonuses/> */}
				<Banners />
			</aside>
		</>
	)
}

function GiftsTable(props) {
	if (props.data.length === 0) {
		return <NoData />
	}

	useEffect(() => {
		console.log('Data updated:', props)
	}, [props])

	const [copiedIndices, setCopiedIndices] = useState([])
	const handleClick = (index, type) => {
		const textToCopy =
			type === 'code'
				? props.data[index].certificate.code
				: props.data[index].certificate.number

		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				setCopiedIndices(prev => [...prev, index])
				setTimeout(() => {
					setCopiedIndices(prev => prev.filter(i => i !== index))
				}, 2000)
			})
			.catch(err => {
				console.error('Ошибка при копировании текста: ', err)
			})
	}

	const getCertificate = useCallback(
		async id => {
			const response = await apiMethods.myGifts.activateGift(id)
			if (response.status === 200) {
				const { certificate, message } = response.data.data

				const actionPayload = {
					type: 'UPDATE_GIFT',
					id,
					certificate,
				}

				if (certificate.status === 'unavailable') {
					actionPayload.message = message
				}

				props.sendGifts(actionPayload)
			}
		},
		[props.sendGifts]
	)

	return (
		<div className='scrollbox'>
			<table className='statTable'>
				<thead>
					<tr>
						<th>Дата оформления</th>
						<th></th>
						<th></th>
						<th>Статус приза</th>

						<th>Баллы</th>
					</tr>
				</thead>
				<tbody>
					{props.data.map((item, idx) => (
						<tr key={idx}>
							<td>{new Date(item.created_at).toLocaleString()}</td>
							<td>
								<img
									className={styles.giftImage}
									src={item.prize.image}
									alt={item.prize.name}
								/>
							</td>
							<td className={styles.name}>{item.prize.name}</td>
							<td>
								<div className={styles.prize_status}>
									<div className={styles.prize_status_text}>
										{item.message && <>{item.message}</>}
										{item.certificate.status === 'unverified' && (
											<>
												<img src='/images/status_wait.svg' alt='На проверке' />{' '}
												{item.certificate.status_description}
											</>
										)}
										{item.certificate.status === 'ready_for_issue' &&
											item.status.slug === 'in_process' && (
												<>
													<img
														src='/images/status_ok.svg'
														alt='Готов к получению'
													/>{' '}
													{item.certificate.status_description}
												</>
											)}
										{item.status.slug === 'approve' &&
											item.certificate.number === null && (
												<>
													<img src='/images/status_ok.svg' alt='Получен' />
													Получен
												</>
											)}
										{item.certificate.status === 'issued' && (
											<>
												<img src='/images/status_ok.svg' alt='Получен' />{' '}
												{item.certificate.status_description}
											</>
										)}
									</div>
									<div>
										<div className={styles.promocode}>
											{item.certificate.status === 'issued' ? (
												<div className={styles.copy}>
													<div
														className={styles.copy_text}
														onClick={() => handleClick(idx, 'number')}
													>
														<div
															className={styles.copy_result}
															style={{
																opacity: copiedIndices.includes(idx) ? 1 : 0,
																transition: 'opacity 0.5s',
															}}
														>
															Скопировано
														</div>
														<span className={styles.width_text}>Номер:</span>{' '}
														{item.certificate.number && item.certificate.number}
														<span className={styles.icon_bg}>
															<img src={'/images/white_copy.svg'} />
														</span>
													</div>
													<div
														className={styles.copy_text}
														onClick={() => handleClick(idx, 'code')}
													>
														<div
															className={styles.copy_result}
															style={{
																opacity: copiedIndices.includes(idx) ? 1 : 0,
																transition: 'opacity 0.5s',
															}}
														>
															Скопировано
														</div>
														<span className={styles.width_text}>Код:</span>{' '}
														{item.certificate.code && item.certificate.code}
														<span className={styles.icon_bg}>
															<img src={'/images/white_copy.svg'} />
														</span>
													</div>
												</div>
											) : (
												item.status.slug === 'in_process' &&
												!item.message && (
													<button
														disabled={
															item.certificate.status === 'unverified'
																? true
																: false
														}
														onClick={() => getCertificate(item.id)}
														className='btn btnPrimary btnSmall'
													>
														Получить сертификат
													</button>
												)
											)}
										</div>
									</div>
									<div>
										{item.certificate.status === 'issued' && (
											<a href='https://upkarta.ru/' target='_blank'>
												Активировать
												<br /> на upkarta.ru
											</a>
										)}
									</div>
								</div>
							</td>
							<td className={styles.flow}>
								-{new Intl.NumberFormat('ru-RU').format(item.points)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
